// Seguimiento de visitas. Antes cada evento se mandaba suelto con userId
// 'anon', así que no se podía seguir el recorrido de nadie ni saber de dónde
// venía. Ahora todos los eventos pasan por aquí: mismo identificador de
// visitante que usa el wizard (funcomunion_anon_id), más el contexto de la
// visita (ruta, de dónde viene, idioma, dispositivo).

const CLAVE_ANON = 'funcomunion_anon_id';

export function visitorId(): string {
  try {
    const u = JSON.parse(localStorage.getItem('funcomunion_user') || 'null');
    if (u?.id || u?.uid) return u.id || u.uid;
    let anon = localStorage.getItem(CLAVE_ANON);
    if (!anon) {
      anon = 'anon_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      localStorage.setItem(CLAVE_ANON, anon);
    }
    return anon;
  } catch {
    return 'anon';
  }
}

// De dónde llega la visita: campaña (utm_source), buscador/red social
// (referrer) o directo. Se guarda en sessionStorage para que no se pierda al
// navegar dentro de la web.
function fuente(): string {
  try {
    const guardada = sessionStorage.getItem('funcomunion_fuente');
    if (guardada) return guardada;
    const utm = new URLSearchParams(window.location.search).get('utm_source');
    let f = utm || '(directo)';
    if (!utm && document.referrer) {
      const host = new URL(document.referrer).hostname.replace(/^www\./, '');
      f = host.includes(window.location.hostname.replace(/^www\./, '')) ? '(interno)' : host;
    }
    sessionStorage.setItem('funcomunion_fuente', f);
    return f;
  } catch {
    return '(directo)';
  }
}

function contexto() {
  if (typeof window === 'undefined') return {};
  return {
    ruta: window.location.pathname,
    fuente: fuente(),
    idioma: (navigator.language || '').slice(0, 5),
    movil: window.matchMedia('(max-width: 768px)').matches,
  };
}

export function track(event: string, data: Record<string, unknown> = {}): void {
  try {
    fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: visitorId(), event, data: { ...contexto(), ...data } }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* nunca debe romper la página */ }
}

// Para beforeunload/visibilitychange: sendBeacon sobrevive al cierre de pestaña.
export function trackBeacon(event: string, data: Record<string, unknown> = {}): void {
  try {
    const cuerpo = JSON.stringify({ userId: visitorId(), event, data: { ...contexto(), ...data } });
    if (navigator.sendBeacon) navigator.sendBeacon('/api/track', new Blob([cuerpo], { type: 'application/json' }));
    else track(event, data);
  } catch { /* ignorar */ }
}
